var motionEvent = function motionEvent(name, target) {
  return new CustomEvent(name, {
    detail: {
      target: target
    }
  });
};
function dispatchPointerEvent(element, name, event) {
  element.dispatchEvent(new CustomEvent(name, {
    detail: {
      originalEvent: event
    }
  }));
}
function dispatchViewEvent(element, name, entry) {
  element.dispatchEvent(new CustomEvent(name, {
    detail: {
      originalEntry: entry
    }
  }));
}
export { dispatchPointerEvent, dispatchViewEvent, motionEvent };